import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import './Application.css';
import { Input } from 'antd';
import { Pagination } from 'antd';
const { Search } = Input;

export default function Application() {
  const [menuData, setMenuData] = useState([])
  const [appCnt, setAppCnt] = useState(0)
  const [newsList, setNewsList] = useState([])
  const [appid, setAppid] = useState(0);
  const [pageIndex, setPageIndex] = useState(1)
  const [ruleList, setRuleList] = useState([])
  const [kw, setKw] = useState('')

  //function chooseCat(catid) {
  const chooseCat = useCallback(async (catid) => {    
    setAppid(catid)
    let url = "https://api.360ep.cn/api/news?&pagesize=16";
    if (kw !== "") {
      url = url + "&kw=" + kw;
    }
    if (catid !== 0) {
      url = url + "&appid=" + catid;
    }

    //console.log(catid)

    axios.get(url).then(
      res => {
        setAppCnt(res.data.total)
        let news = []
        if (res.data.total > 0) {
          res.data.data.forEach(item => {
            news.push(
              {
                itemid: item.Itemid,
                title: item.Title,
                thumb: item.Thumb === "" ? "img/u54.png" : item.Thumb,
                intro: item.Introduce,
                url: "https://info.360ep.cn/news/show.php?itemid=" + item.Itemid,
                company: item.Company,
                mallcnt: item.MallCnt
              }
            );
          });
        }        
        setNewsList(news)
      }
    )
  }, [kw]);

  useEffect(() => {
    let source = axios.CancelToken.source();

    async function fetchData() {
      try {
        let res;
        const cachedData = localStorage.getItem("categories");
        // 如果有缓存数据，直接使用
        if (cachedData) {
          res = JSON.parse(cachedData);
        } else {
          // 从远程获取数据
          res = await axios.get("https://api.360ep.cn/api/category/?type=sep", {
            cancelToken: source.token,
          });

          // 将获取到的数据存储到localStorage中
          localStorage.setItem("categories", JSON.stringify(res.data));
          res = res.data;
        }

        let menuItems = [];
        res.data.forEach(item => {
          menuItems.push(
            {
              label: item.catname,
              key: item.catid
            }
          );
        });

        chooseCat(0);
        setMenuData(menuItems);
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log("Request canceled", error.message);
        } else {
          console.log("Error", error.message);
        }
      }
    }

    async function fetchNews() {
      axios.get("https://api.360ep.cn/api/news?pagesize=12&level=18").then(
        res => {
          let news = []
          res.data.data.forEach(item => {
            news.push(
              {
                itemid: item.Itemid,
                title: item.Title,
                thumb: item.Thumb === "" ? "img/u54.png" : item.Thumb,
                intro: item.Introduce,
                url: "https://info.360ep.cn/news/show.php?itemid=" + item.Itemid,
                company: item.Company,
                mallcnt: item.MallCnt
              }
            );
          });
          setRuleList(news)
        }
      )
    }

    fetchData();
    fetchNews();

    return () => {
      source.cancel("Request canceled by user");
    };
  }, [chooseCat]);

  function pageChoose(page, pageSize) {
    setPageIndex(page)
    let url = "https://api.360ep.cn/api/news?page=" + page + "&pagesize=" + pageSize;
    if (kw !== "") {
      url = url + "&kw=" + kw;
    }
    if (appid !== 0) {
      url = url + "&catid=" + appid;
    }
    axios.get(url).then(
      res => {
        setAppCnt(res.data.total)
        let news = []
        if (res.data.total > 0) {
          res.data.data.forEach(item => {
            news.push(
              {
                itemid: item.Itemid,
                title: item.Title,
                thumb: item.Thumb === "" ? "img/u54.png" : item.Thumb,
                intro: item.Introduce,
                url: "https://info.360ep.cn/news/show.php?itemid=" + item.Itemid,
                company: item.Company,
                mallcnt: item.MallCnt
              }
            );
          });
        }
        setNewsList(news)
      }
    )
  }

  const handleSearch = (value) => {
    if (value === "") {
      return;
    }

    setKw(value)
    axios.get("https://api.360ep.cn/api/news?pagesize=16&kw=" + value).then(
      res => {
        setAppCnt(res.data.total)
        let news = []
        if (res.data.total > 0) {
          res.data.data.forEach(item => {
            news.push(
              {
                itemid: item.Itemid,
                title: item.Title,
                thumb: item.Thumb === "" ? "img/u54.png" : item.Thumb,
                intro: item.Introduce,
                url: "https://info.360ep.cn/news/show.php?itemid=" + item.Itemid,
                company: item.Company,
                mallcnt: item.MallCnt
              }
            );
          });
        }
        setNewsList(news)
      }
    )
  };

  return (
    <div className='app-body'>
      <div className='app-search'>
        <div className='app-search-item'><span className='app-search-title1'>应用案例查询</span><span className='app-search-title2'>专业应用数据服务平台</span></div>
        <div className='app-search-item'><Search
          placeholder="请输入应用关键词一键智能搜索"
          enterButton="搜索"
          classNames="search-input"
          size="large"
          onSearch={handleSearch}
        /></div>
        <div className='app-search-item'><div className='app-search-title3'>已收录相关应用案例<span className='app-search-title4'>{appCnt}</span>条</div></div>
      </div>
      <div className='app-catlist'>
        {
          menuData.map((item) => {
            return (
              <div className={item.key === appid ? 'app-cat-item-choose' : 'app-cat-item'}  key={item.key}>
                <span onClick={() => chooseCat(item.key)}>{item.label}</span>
              </div>
            )
          })
        }
      </div>
      <div className='app-contentlist'>
        <div className='app-content-list'>
          {
            newsList.map((item, index) => {
              return (
                <div className='app-content-item' key={index}>
                  <a href={item.url} target='_blank' rel="noopener noreferrer" className='app-content-item-link'><img src={item.thumb} alt={item.title} /></a>
                  <div className='app-content-item-title'>{item.title}</div>
                  <div className='app-content-item-intro'>{item.intro}</div>
                  <div className='app-content-item-more'><a href={item.url} target='_blank' rel="noopener noreferrer">[查看全文]</a></div>
                  <div className='app-content-item-company'>相关企业: {item.company}</div>
                  <div className='app-content-item-mallcnt'><a href='/#/market'>相关应用材料{item.mallcnt}条</a></div>
                </div>
              )
            })
          }
          {
            newsList.length > 0 && (
              <div className='mall-page'><Pagination current={pageIndex} total={appCnt} pageSize={20} showSizeChanger={false} onChange={pageChoose} /></div>
            )
          }
          {
            newsList.length === 0 && (
              <div className='mall-page'>暂无相关案例</div>
            )
          }
        </div>
        <div className='app-content-rule'>
          <div className='app-content-rule-title'>相关法规</div>
          {
            ruleList.map((item, index) => {
              return (
                <div className='app-content-rule-item' key={index}><a href={item.url} target='_blank' rel="noopener noreferrer">{item.title}</a></div>
              )
            })
          }
        </div>
      </div>
    </div>
  )
}
